import React, { useEffect, useMemo } from "react";
import { RiCloseLine } from "react-icons/ri";
import { PictureInPictureVideo } from "../../../Table/PictureInPictureVideo";
import moment from "moment";

// type AttachmentProps = FileAttachment | GroupAttachment | VideoAttachment

// type FileAttachment = {
//   file: File
//   type: 'file'
//   onRemove: () => void
// }

// type GroupAttachment = {
//   label: string
//   swingsAmount: number
//   type: 'group'
//   onRemove: () => void
// }

// type VideoAttachment = {
//   type: 'video'
//   video: File | string
//   onRemove: () => void
// }

const Attachment = (props) => {
  const isVideo = props.type === "video";
  const video = isVideo ? props.video : null;

  const videoUrl = useMemo(() => {
    if (!isVideo || !video) return null;
    return video instanceof File ? URL.createObjectURL(video) : video;
  }, [isVideo, video]);

  useEffect(() => {
    if (!videoUrl || !videoUrl.startsWith("blob:")) return;
    return () => URL.revokeObjectURL(videoUrl);
  }, [videoUrl]);

  if (props.type === "file") {
    const { file, onRemove } = props;
    return (
      <div
        className="bg-grayTrue700 flex flex-row items-center justify-between gap-2 rounded-lg px-3 py-2"
        title={`${file?.name} (${(file?.size / 1024).toFixed(1)} KB)`}
      >
        <div className="flex flex-col gap-0.5">
          <div className="max-w-[100px] truncate text-xs font-bold text-white">
            {file?.name.split(".")[0]}
          </div>

          <div className="text-grayTrue400 text-xs">
            .{file?.name.split(".")[1]}
          </div>
        </div>

        <RiCloseLine
          className="text-grayTrue500 hover:text-gray300 size-4 cursor-pointer transition-colors"
          onClick={onRemove}
        />
      </div>
    );
  }

  if (props.type === "video") {
    const { onRemove } = props;
    if (!videoUrl) return null;

    return (
      <div
        className="bg-grayTrue700 flex flex-row items-center justify-between gap-2 rounded-lg px-3 py-2"
        style={{ minWidth: 152 }}
      >
        <PictureInPictureVideo videoPath={videoUrl} />

        <div className="flex flex-col gap-0.5">
          <div className="text-gray200 text-sm">You</div>
          <div className="text-gray400 text-xs">
            {moment().format("DD/MM/YYYY")}
          </div>
        </div>

        <RiCloseLine
          className="text-grayTrue400 hover:text-gray300 size-4 transition-colors"
          onClick={onRemove}
        />
      </div>
    );
  }

  if (props.type === "group") {
    const { label, onRemove, swingsAmount } = props;
    return (
      <div
        className="bg-grayTrue700 flex flex-row items-center justify-between gap-2 rounded-lg px-3 py-2"
        style={{ minWidth: 152 }}
      >
        <div className="flex flex-col gap-0.5">
          <div className="text-gray200 text-sm">{label}</div>
          <div className="text-gray400 text-xs">
            {swingsAmount} swing{swingsAmount !== 1 ? "s" : ""}
          </div>
        </div>

        <RiCloseLine
          className="text-grayTrue400 hover:text-gray300 size-4 transition-colors"
          onClick={onRemove}
        />
      </div>
    );
  }

  return null;
};

export default Attachment;
